import req from "@/assets/js/axios"
import store from './../../store'
import { MessageBox } from 'element-ui'
import qs from 'qs'
import router from '../../router.js'
import md5 from 'js-md5';
import Cryptopt from 'jsencrypt';
//process.env.VUE_APP_CASTLE_UR;//用户信息
//process.env.VUE_APP_HZW_URL;//常规
class Fn {

  test() {
    console.log('公共方法')
  }

  /*获取用户信息*/
  getUserInfo(Deal) {
    return new Promise(resolve => {
      req.apiAxios('POST', `/host/user/UserController/getUserInfo`, {loginKey: sessionStorage.getItem('loginKey')}, Deal).then(res => {
        let info = null;
        if (res.error.err_code === 0) {
          let list = res.obj.list || [];
          info = list[0] || null;
          store.dispatch('setInfo', info);
          sessionStorage.setItem('userId', info.id)
          sessionStorage.setItem('user_id', info.id)
        }
        resolve(info);
      })
    })
  }

  // 获取用户当前选中的企业
  getEnterpriseInfo() {
    return new Promise(resolve => {
      return req.apiAxios("GET", '/enterprise/EnterpriseController/starry-security/getInfo').then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        // 获取所属企业
        let company = list.length ? list[0].name : "";
        // 获取所属企业地址
        let company_address = list.length ? list[0].province_name + list[0].city_name + list[0].address : "";
        store.dispatch("setCompany", company);
        store.dispatch("setCompanyAddress", company_address);
        store.dispatch("setCompanyObj", list[0]);
        resolve(company)
      })
    })
  }
  // 获取用户当前选中的企业(以后慢慢替换上面的使用)
  getEnterpriseInfoObj() {
    return new Promise(resolve => {
      return req.apiAxios("GET", '/enterprise/EnterpriseController/starry-security/getInfo').then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list.length?res.obj.list[0]:null;
        store.dispatch("setCompanyObj", list);
        resolve(list)
      })
    })
  }
  // 获取用户当前选中的员工信息
  getEmployeeInfo() {
    return new Promise(resolve => {
      return req.apiAxios("GET", '/employee/EmployeeController/starry-security/getInfo').then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        let employee = list.length ? list[0] : {};
        store.dispatch("setEmployee", employee);
        resolve(employee)
      })
    })
  }
  /*获取选中园区信息*/
  getParkInfo(Deal) {
    return new Promise(resolve => {
      req.apiAxios('POST', `/incubator/IncubatorController/starry-security/getInfo`, { is_incubator: false }, Deal).then(res => {
        let info = null;
        if (res.error.err_code === 0) {
          let list = res.obj.list || [];
          info = list[0] || null;
          store.dispatch('setPark', info);
        }
        resolve(info);
      })
    })
  }

  /*退出登录*/
  exitLogin() {
    return new Promise(resolve => {
      return req.apiAxios('POST', `/host/user/UserController/exitLogin`).then(res => {
        if (res.error.err_code !== 0) return;
        store.dispatch('setInfo', null)
        sessionStorage.clear();
        window.location.reload(true);
        resolve();
      })
    })
  }
   /*获取同域名下的登录凭证*/
   getLoginKey(Deal) {
    return new Promise(resolve => {
      req.apiAxios('POST', `/sctccPerson/user/UserController/getLoginKey`, {}, Deal).then(res => {
        resolve(res);
      })
    })
  }
  /**
   *  @desc  获取url参数
   *  @param  {String} url为穿过来的链接
   *  @param  {String} id为参数名
   */
  GetParam(url, id) {
    url = url + "";
    var regstr = "/(\\?|\\&)" + id + "=([^\\&]+)/";
    var reg = eval(regstr);
    //eval可以将 regstr字符串转换为 正则表达式
    var result = url.match(reg);
    if (result && result[2]) {
      return result[2];
    }
  }

  /** 日期时间格式转化*/
  formatDate(date, fmt) {
    let o = {
      "M+": date.getMonth() + 1,                 //月份
      "d+": date.getDate(),                    //日
      "H+": date.getHours(),                   //小时
      "m+": date.getMinutes(),                 //分
      "s+": date.getSeconds(),                 //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  }


  /**
   * 克隆对象
   * @param obj 要克隆的对象
   */
  clone(obj) {
    return JSON.parse(JSON.stringify(obj))
  };

  /**
   * 用于富文本显示
   * */
  filterHtml(obj) {
    if (obj && typeof obj === 'string') {
      let msg = obj.replace(/<[^>]+>|&[^>]+;/g, "").trim(); //去掉所有的html标签和&nbsp;之类的特殊符合
      msg = msg.replace(/[|]*\n/, ''); //去除行尾空格
      // msg = msg.replace(/&nbsp;/ig, ''); //去掉npsp
      // msg = msg.replace(/&ldquo;/ig, ''); //去掉npsp
      // msg = msg.replace(/&rdquo;/ig, ''); //去掉npsp
      // msg = msg.replace(/&middot;/ig, ''); //去掉npsp
      // msg = msg.replace(/&hellip;/ig, ''); //去掉npsp
      // msg = msg.replace(/&mdash;/ig, ''); //去掉npsp
      // msg = msg.replace(/&gt;/ig, ''); //去掉npsp
      // msg = msg.replace(/&lt;/ig, ''); //去掉npsp
      return msg.trim();
    }
    return obj;
  };
   // 上传的图片文件转base64编码
   readFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.addEventListener("load", function () {
        let src = reader.result;
        resolve(src)
      }, false);
      reader.onerror = () => {
        const err = new Error('读取图片失败')
        reject(err.message)
      }
      if (file) {
        reader.readAsDataURL(file);
      }
    })
  }
  setCookie(name, value, expires, domain, path, secure) {
    var cookieText = "";
    cookieText += encodeURIComponent(name) + "=" + encodeURIComponent(value);
    if (expires instanceof Date) {
      cookieText += "; expires=" + expires.toGMTString();
    }
    if (path) {
      cookieText += "; path=" + path;
    }
    if (domain) {
      cookieText += "; domain=" + domain;
    }
    if (secure) {
      cookieText += "; secure";
    }
    document.cookie = cookieText;
  }

  getCookie(name) {
    var cookieName = encodeURIComponent(name) + "=",
      cookieStart = document.cookie.indexOf(cookieName),
      cookieValue = "";
    if (cookieStart > -1) {
      var cookieEnd = document.cookie.indexOf(";", cookieStart);
      if (cookieEnd == -1) {
        cookieEnd = document.cookie.length;
      }
      cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd));
    }
    return cookieValue;
  }

  unsetCookie(name, domain, path, secure) {
    this.set(name, "", Date(0), domain, path, secure);
  }

  /**
   * 计算字符串长度，中文字符占两个，英文字符占一个
   * @param str
   * @returns {number}
   */
  getStringLength(str) {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  }

  /**
   * 获得uuid
   * @returns {string}
   */
  uuid() {
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
  }

  //非对称加密
  encryptRSA(data){
    //公钥
    const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDJvm05OVwDWFmjeAp8VUvDeB22miMoaAwPKkMfzbvp5NSWY12EJb6EJD2NvtcclfFmV7G6k6I6nYkmTF+7F+FTrK7JSvCYWGi4NP51PnYuvCLTpBz7SN3RhfPvpvB5Mt2I00CrdH7wYOb7uqVsKdURCgGnzYOTWXRxka/8coB9uwIDAQAB';
    const encrypt = new Cryptopt();
    encrypt.setPublicKey(publicKey);
    //返回加密数据
    return encrypt.encrypt(data);
  }

  //md5
  encryptMD5(data){
    return md5(data);
  }

  //密码md5加密
  async pswMD5(data){
    let res = await this.getServerTime();
    console.log(this.formatDate(new Date(res),'yyyy-MM-dd HH:mm:ss'))
    console.log(new Date(res).getTime())
    //时间戳
    let timestamp = new Date(res).getTime();
    //密码加密
    let password = md5(data);
    //密码加上时间戳加密
    password = md5(timestamp+''+password);
    return {timestamp,password}
  }

  //获取服务器时间
  getServerTime(){
    return new Promise((resolve,reject)=>{
      var xhr = new XMLHttpRequest();
      if( !xhr ){
        xhr = new ActiveXObject("Microsoft.XMLHTTP");
      }
      xhr.open("GET",process.env.VUE_APP_SCTCC_CASTLE_URL+'/currentTimeMillis',true);
      xhr.onreadystatechange=function(res){
        if( xhr.readyState == 4 && xhr.status == 200 ){
          let res = JSON.parse(xhr.responseText);
          resolve(res.obj.timestamp)
        }
      }
      xhr.send(null);
    })
  }
  // 获取滚动条的宽度
    getScrollbarWidth() {
      var odiv = document.createElement("div"), //创建一个div
        styles = {
          width: "100px",
          height: "100px",
          overflowY: "scroll" //让他有滚动条
        },
        i,
        scrollbarWidth;
      for (i in styles) odiv.style[i] = styles[i];
      document.body.appendChild(odiv); //把div添加到body中
      scrollbarWidth = odiv.offsetWidth - odiv.clientWidth; //相减
      odiv.remove(); //移除创建的div
      return scrollbarWidth; //返回滚动条宽度
    }
}

function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};

export default new Fn();
